import { render } from "./S248213.vue?vue&type=template&id=8919a734"
const script = {}
script.render = render

export default script